import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import WebsiteLayout from "./WebsiteLayout";
import LandingPage from "./LandingPage";
import AboutPage from "./AboutPage";
import ContactPage from "./ContactPage";
import FAQPage from "./FAQPage";
import ComplianceFrameworksPage from "./ComplianceFrameworksPage";
import GlobalPrivacyPage from "./GlobalPrivacyPage";
import TPRMPage from "./TPRMPage";

const MultiTabWebsite = () => {
  const [activeTab, setActiveTab] = useState('platform');
  const navigate = useNavigate();
  const location = useLocation();

  // Update active tab based on URL path
  useEffect(() => {
    const path = location.pathname;
    if (path === '/' || path === '/platform') {
      setActiveTab('platform');
    } else if (path === '/about') {
      setActiveTab('about');
    } else if (path === '/contact') {
      setActiveTab('contact');
    } else if (path === '/faq') {
      setActiveTab('faq');
    } else if (path === '/compliance-frameworks') {
      setActiveTab('compliance-frameworks');
    } else if (path === '/global-privacy') {
      setActiveTab('global-privacy');
    } else if (path === '/tprm') {
      setActiveTab('tprm');
    }
  }, [location.pathname]);

  // Update URL when tab changes
  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    
    switch (tabId) {
      case 'platform':
        navigate('/website', { replace: true });
        break;
      case 'about':
        navigate('/website/about', { replace: true });
        break;
      case 'contact':
        navigate('/website/contact', { replace: true });
        break;
      case 'faq':
        navigate('/website/faq', { replace: true });
        break;
      case 'compliance-frameworks':
        navigate('/website/compliance-frameworks', { replace: true });
        break;
      case 'global-privacy':
        navigate('/website/global-privacy', { replace: true });
        break;
      case 'tprm':
        navigate('/website/tprm', { replace: true });
        break;
      default:
        navigate('/website', { replace: true });
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'platform':
        return <LandingPage />;
      case 'about':
        return <AboutPage />;
      case 'contact':
        return <ContactPage />;
      case 'faq':
        return <FAQPage />;
      case 'compliance-frameworks':
        return <ComplianceFrameworksPage />;
      case 'global-privacy':
        return <GlobalPrivacyPage />;
      case 'tprm':
        return <TPRMPage />;
      default:
        return <LandingPage />;
    }
  };

  return (
    <WebsiteLayout activeTab={activeTab} setActiveTab={handleTabChange}>
      {renderContent()}
    </WebsiteLayout>
  );
};

export default MultiTabWebsite;